import { render, staticRenderFns } from "./genealogyMobile.vue?vue&type=template&id=be3a8b32&scoped=true"
import script from "./genealogyMobile.vue?vue&type=script&lang=js"
export * from "./genealogyMobile.vue?vue&type=script&lang=js"
import style0 from "./genealogyMobile.vue?vue&type=style&index=0&id=be3a8b32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3a8b32",
  null
  
)

export default component.exports